import React, { Fragment } from "react";
import { checkEmpty } from "services/utils/commonFunctions/CommonFunctions";

const FormSection = ({ children,subClass, title, status,subtitle,subheading, isLoading = false,heightCss=false,search=false,inputSearch=null,filterSearch=null,sortBy=null,editDetais=null,isCheck=null,assignToButton=null,imageName=null,rowMax=true,salesButton=null,historybtn=false }) => {
  return (
    <Fragment>
      <div className={`${heightCss?"panel-card cardpane ":"panel-card"} ${subClass?subClass:''}`}>
        {(search||editDetais||title)&&<div className={title || search ? "panel-heading" : "col"}>
        {imageName&&<img src={imageName} alt="family image" />}
          {title}
          {search && inputSearch()}
          &nbsp;{search && filterSearch()}
          {search && sortBy()}
          {
            historybtn && <span style={{float:"right"}}>
              <button className={"btn btn-xs btn-primary"}>
                History
          </button></span>
          }
          {subtitle&&<span className="span">
            {`(${subtitle})`}
          </span>}
          {subheading&&<span
            className="subheading mt-3"
          >
            {subheading}
          </span>}          
        </div>
        }
        <div className={`panel-body ${rowMax?"row mx-0":""}`}>{children}</div>
      </div>
    </Fragment>
  );
};

export default FormSection;
